import { postsList } from "../../actions/blog/_GetPostsListAction";
import { SearchBox } from "../../components/search";

const $search = $("#search");

const search_posts = () => {
    const query = $search.val();

    return postsList(query, null, null, "all").then((response) => {
        return response && response.length > 0 ? response : null;
    });
};

new SearchBox("search", search_posts, {
    searching: () => {
        $("#referral~.pi-search").hide();
        $("#referral~.is_loading").show();
    },
    done: () => {
        $("#referral~.pi-search").show();
        $("#referral~.is_loading").hide();
    },
    select: {
        enable: true,
        title: (data) => data.title ?? "",
        key: "id",
    },
    onSelect: (key) => {
        window.location.href = "/blog/post/" + key;
    },
}).render();
